import { faSearch, faRuler, faCube, faTools, faUser , faTint, faBell} from '@fortawesome/free-solid-svg-icons';

const filterConfig = [
  { field: "fromDate", type: "date", label: "From", icon: null, view: "creation_date_range_after" }, 
  { field: "toDate", type: "date", label: "To", icon: null, view: "creation_date_range_before" }, 
  { field: "observation", type: "text", label: "Observation", placeholder: "Observation", icon: faUser, view: "observation_id" },
  { field: "leak", type: "text", label: "Leak", placeholder: "Leak", icon: faTint, view: "leak_id" },
  { field: "notificationDate", type: "date", label: "Date", placeholder: "Notification Date", icon: faBell, view: "notification_date" } 
];

export default filterConfig;